const API_BASE = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');

export function apiUrl(pathOrUrl: string): string {
  if (pathOrUrl.startsWith('http')) return pathOrUrl;
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${API_BASE}${path}`;
}

export async function fetchJSON<T>(pathOrUrl: string, init?: RequestInit): Promise<T> {
  const res = await fetch(apiUrl(pathOrUrl), {
    cache: 'no-store',
    ...init,
  });

  if (!res.ok) {
    let body = '';
    try { body = await res.text(); } catch { /**/ }
    throw new Error(`HTTP ${res.status}${body ? `: ${body}` : ''}`);
  }

  return (await res.json()) as T;
}